var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-cards",attrs:{"data-component-name":"no-cards"}},[_c('div',{staticClass:"grid-container"},[[_vm._m(0)]],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-cards"},[_c('div',{staticClass:"dotted-line"},[_c('span',{staticClass:"lt-CreditCards lg-icon"}),_vm._v(" "),_c('p',[_vm._v("Use the search bar to add cards to compare.")])])])
}]

export { render, staticRenderFns }